import ActionTypes from "../../../constants/ActionTypes";
import { IPageShellState, ISetPageShellAction, INormalizedPageShellAction, IFetchPageShellSessionAction, IFetchPageShellHeaderAction, ISetLoginDataAction } from "./types";

export function setPageShellAction(pageShellState: IPageShellState): ISetPageShellAction {
  return {
    type: ActionTypes.PAGE_SHELL.SET,
    payload: pageShellState,
  };
}

export function fetchPageShellSessionAction(): IFetchPageShellSessionAction {
  return {
    type: ActionTypes.PAGE_SHELL.FETCH_SESSION,
  };
}

export function fetchPageShellHeaderAction(): IFetchPageShellHeaderAction {
  return {
    type: ActionTypes.PAGE_SHELL.FETCH_HEADER,
  };
}


export function normalizedPageShellAction(pageShell: IPageShellState): INormalizedPageShellAction {
  return {
    type: ActionTypes.PAGE_SHELL.PROCESS,
    payload: pageShell,
  };
}

export function setLoginDataAction(pageShellState: IPageShellState): ISetLoginDataAction {
  return {
    type: ActionTypes.PAGE_SHELL.SET_LOGIN_DATA,
    payload: pageShellState,
  };
}
